import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { RouterModule } from '@angular/router';
import { AppTopBarComponent } from './app.topbar.component';
import { AppSidebarComponent } from './app.sidebar.component';
import { AppFooterComponent } from './app.footer.component';
import { AppLayoutComponent } from './app.layout.component';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { StyleClassModule } from 'primeng/styleclass';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { GlobalProgressSpinnerComponent } from './global-controls/global-progress-spinner.component';
import { SignInAsBannerComponent } from './sign-in-as-banner/sign-in-as-banner.component';
import { SignInAsRefusalComponent } from './sign-in-as-banner/sign-in-as-refusal.component';
import { PopoverModule } from 'primeng/popover';
import { UserMenuComponent } from './user-menu/user-menu.component';

@NgModule({
  declarations: [
    AppMenuitemComponent,
    AppTopBarComponent,
    AppSidebarComponent,
    AppFooterComponent,
    AppMenuComponent,
    AppLayoutComponent,
    AppBreadcrumbComponent,
    GlobalProgressSpinnerComponent
  ],
  exports: [AppLayoutComponent, GlobalProgressSpinnerComponent],
  imports: [
    BrowserModule,
    FormsModule,
    InputTextModule,
    MenuModule,
    RouterModule,
    StyleClassModule,
    BadgeModule,
    RadioButtonModule,
    RippleModule,
    RouterModule,
    TooltipModule,
    SignInAsBannerComponent,
    SignInAsRefusalComponent,
    PopoverModule,
    UserMenuComponent
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class AppLayoutModule {}
